import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../Loader";

const Slider = ({ imageArray, offerImage, isLoading,slug }) => {
  const [sliderIndex, setSliderIndex] = useState(0);
const [fade, setFade] = useState(true);

useEffect(() => {
  const interval = setInterval(() => {
    setFade(false); // start fade out
    setTimeout(() => {
      setSliderIndex((prev) => (prev === imageArray.length - 1 ? 0 : prev + 1));
      setFade(true); // fade in new image
    }, 100); // duration should match CSS fade time
  }, 5000);

  return () => clearInterval(interval);
}, [sliderIndex, imageArray.length]);


  console.log(sliderIndex, "<<<", imageArray);

  let ele = document?.getElementById("no_right_click");
  ele?.addEventListener("contextmenu", (ev) => {
    ev?.preventDefault(); // this will prevent browser default behavior
  });

  let elee = document?.getElementById("no_rightclick");
  elee?.addEventListener("contextmenu", (ev) => {
    ev?.preventDefault(); // this will prevent browser default behavior
  });
  return (
    <section
      className="home-slider style-2 position-relative "
      // style={{ marginBottom: "100px" }}
    >
      <div className="container">
        {!isLoading ? (
          <div className="row">
            <div className="col-xl-8 col-lg-12" id="no_right_click">
              <div className="home-slide-cover">
                <div className="hero-slider-1 style-4 dot-style-1 dot-style-1-position-1">
                  <div
                    className="single-hero-slider single-animation-wrap"
                    style={{
                      backgroundImage: imageArray[0]
                        ? `url(${
                            process.env.REACT_APP_BASE_URL +
                            "/storage/" +
                            imageArray[sliderIndex]?.image
                          })`
                        : "url(/images/banner/1leftTop.jpg)",
                      opacity: fade ? 1 : 0,
                      transition: "opacity 0.3s ease-in-out",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      // display: sliderIndex == 1 ? "block" : "none",
                    }}
                  ></div>
                  {/* <div
                    className="single-hero-slider single-animation-wrap"
                    style={{
                      backgroundImage: imageArray[1]?.image
                        ? `url(${
                            process.env.REACT_APP_BASE_URL +
                            "/storage/" +
                            imageArray[1]?.image
                          })`
                        : "url(/images/banner/2leftTop.jpg)",
                      display: sliderIndex == 2 ? "block" : "none",
                    }}
                  >
                    <div className="slider-content">
                    
                    </div>
                  </div> */}
                </div>
                <div className="slider-arrow hero-slider-1-arrow" />
              </div>
            </div>
            <div className="col-lg-4 d-none d-xl-block" id="no_rightclick">
              <div
                className="banner-img style-3 animated animated"
                style={{
                  backgroundImage: offerImage
                    ? `url(${
                        process.env.REACT_APP_BASE_URL +
                        "/storage/" +
                        offerImage
                      })`
                    : `url(/images/banner/3leftTop.jpg)`,
                  //  no-repeat center bottom;
                }}
              >
                <div className="banner-text " style={{ marginTop: "366px" }}>
                  <h2 className="mb-50">
                    {/* Delivered <br />
                                    to */}
                    <span className="text-brand">
                      {/* your
                                        <br />
                                        home */}
                    </span>
                  </h2>
                  <Link
                    to={`/product-category/${slug}/1`}
                    className="btn btn-xs"
                  >
                    Shop Now <i className="fi-rs-arrow-small-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              minHeight: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Loader />
            <h6 className="mt-3">
              It may take a few seconds to load for first time...
            </h6>
          </div>
        )}
      </div>
    </section>
  );
};

export default Slider;
